<div class="delivery flex__child--auto flex--column" data-test="delivery">
  <router-outlet></router-outlet>
</div>
